export default "__VITE_ASSET__CDi9xbHv__"